import $ from "jquery"
import { trace } from "./../shared/helpers.js"
import Cookies from "./../shared/Cookies.js";

const FontResize = {
  
  init() {
    $('body').on('click', '#font-resize', (e)=> {
      e.preventDefault();
      let $t = $(e.target);
      let size = $t.data("size");
      if (!size) {
        size = $('html').hasClass("font-size-2") ? 1 : 2;
      }
      Cookies.createCookie("u_font_size", size, 1);
      // refresh
      location.reload();
    });

    $('body').on('click', '#contrast', (e)=> {
      e.preventDefault();
      let cont = $('html').hasClass("contrast") ? 0 : 1;
      Cookies.createCookie("u_contrast", cont, 1);
      // refresh
      location.reload();
    });

    
  }

}

export default FontResize;